import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Convidar membro',
  description:
    'A pessoa recebe um link por e-mail e entra ou cria a conta com esse e-mail. O convite vale 14 dias.',
  email: 'E-mail',
  emailPlaceholder: 'nome@organizacao.com.br',
  role: 'Acesso',
  roles: {
    editor: {
      label: 'Edição',
      description: 'Cria e edita eventos e ofertas e envia para análise',
    },
    viewer: {
      label: 'Leitura',
      description: 'Acompanha eventos, ofertas e resultados, sem editar',
    },
  },
  cancel: 'Cancelar',
  submit: 'Enviar convite',
  sent: 'Convite enviado',
  sentTitle: 'Convite enviado',
  sentText:
    'O link foi para {{email}} e vale até {{date}}. Também dá para copiar e enviar por outro canal.',
  link: 'Link do convite',
  copy: 'Copiar link',
  copied: 'Link copiado',
  copyError: 'Não foi possível copiar o link',
  done: 'Concluir',
  submitError: 'Não foi possível enviar o convite. Tente de novo',
} satisfies TranslationTree;
